import { ToggleButtonGroup, Typography } from '@maia/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { useFilter } from '../../../utils/filter/filter';
import { Tasks, getTasksOptions } from './queryOptions';
import { TaskList } from '../../shared/task/list';
import { isEmpty } from 'es-toolkit/compat';

type tasksListProps = {
  tasks: Tasks;
};

export function TasksList(props: tasksListProps) {
  const { tasks } = props;
  const { guid } = useParams({
    from: '/_authenticated/customers/$guid/_layout/tasks',
  });
  const {
    state,
    mappedState,
    dispatch: setSearch,
  } = useFilter('/customers/$guid/tasks');

  const { data } = useSuspenseQuery(
    getTasksOptions(guid, { ...mappedState, limit: undefined }, tasks),
  );

  if (isEmpty(data?.response)) {
    return (
      <div className="flex flex-col gap-y-24 col-span-full w-full">
        <div className="flex gap-x-24">
          <ToggleButtonGroup
            defaultSelectedKey={
              state.filter?.find(([key]) => key === 'status')?.[1]
            }
            items={[
              { label: 'Openstaand', value: 'in_review' },
              { label: 'Afgerond', value: 'closed' },
            ]}
            onChange={(status) =>
              setSearch({
                type: 'setFilter',
                payload: ['status', status],
              })
            }
          />
        </div>
        <div className="flex flex-col w-full justify-center items-center p-64 border border-grayscale100 rounded-8">
          <img
            src={`/images/illustrations/empty-table.svg`}
            alt={'Geen resultaten gevonden'}
            className="object-contain w-[190px] h-[155px]"
          />
          <Typography
            variant="body-l"
            weight="medium"
            className="text-grayscale600"
          >
            Geen resultaten gevonden
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <TaskList
      tasks={data?.response ?? []}
      filterSlot={
        <div className="flex gap-x-24">
          <ToggleButtonGroup
            defaultSelectedKey={
              state.filter?.find(([key]) => key === 'status')?.[1]
            }
            items={[
              { label: 'Openstaand', value: 'in_review' },
              { label: 'Afgerond', value: 'closed' },
            ]}
            onChange={(status) =>
              setSearch({
                type: 'setFilter',
                payload: ['status', status],
              })
            }
          />
        </div>
      }
    />
  );
}
